import { query } from "../shared/styled/Theme";
import { isBefore, parseISO } from "date-fns";
export const isSmContainer = (params) => {
  return !!params?.sm;
};

export const isXsContainer = (params) => {
  return !!params?.xs;
};

export const isXxsContainer = (params) => {
  return !!params?.xxs;
};

export const isD3Column9 = (params) => {
  return !!params?.d3_col_9;
};

export const isFeaturedMatchXxs = (params) => {
  return !!params?.featuredMatchXxs;
};

export const featuredMatchCustomQueries = {
  ...query,
  featuredMatchXxs: { minWidth: 0, maxWidth: 320 },
  d3_col_9: { minWidth: 575, maxWidth: 1800 },
};

export function sortMatchesByDate(mlsMatches) {
  return mlsMatches?.sort((a, b) => {
    return new Date(a.planned_kickoff_time) - new Date(b.planned_kickoff_time);
  });
}

export function groupMatchesByStatus(mlsMatches) {
  const scheduledMatches = [];
  const completedMatches = [];

  // const today = new Date();

  mlsMatches?.forEach((match) => {
    // if (isBefore(parseISO(match?.planned_kickoff_time), today)) {
    if (match?.match_status === "finalWhistle") {
      completedMatches.push(match);
    } else {
      scheduledMatches.push(match);
    }
  });

  return { scheduledMatches, completedMatches };
}

export function composeFeaturedMatches({
  completedMatches,
  scheduledMatches,
  previousMatchesCount,
  nextMatchesCount,
}) {
  const previousMatches = previousMatchesCount
    ? completedMatches.slice(
        -Math.min(previousMatchesCount, completedMatches.length)
      )
    : [];

  const featuredMatch =
    scheduledMatches.length > 0 ? scheduledMatches[0] : null;

  const nextMatches = nextMatchesCount
    ? scheduledMatches.slice(
        1,
        Math.min(nextMatchesCount + 1, scheduledMatches.length)
      )
    : [];

  return {
    previousMatches,
    featuredMatch,
    nextMatches,
  };
}
export function getClubSportecId() {
  return window?.forgeVariables?.currentSite?.clubSportecId;
}
